export default __webpack_public_path__ + "static/blog6-bcb5415825136fbfa035c524aca18af1.jpg";